import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { slotsAction } from "src/store/Slices/Administrator/SlotsSlice";
import AddEditSlotsModal from "./Modals/AddEditSlotsModal";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Slots = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);
    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Слот" },
        { label: "По дате", value: 2, index: "date", title: "Дата" },
        { label: "По времени", value: 3, index: "time", title: "Время" },
        { label: "По услуге", value: 4, index: "serviceName", title: "Услуга" },
        { label: "По клубу", value: 5, index: "clubName", title: "Клуб" },
        { label: "По тренеру", value: 6, index: "employName", title: "Тренер" },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [slotsInfo, setSlotsInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const slotsList = useSelector((state) => state.SlotsSlice.slotsList);
    const slotsListLoading = useSelector(
        (state) => state.SlotsSlice.slotsListLoading
    );

    const onClickDelete = () => {
        dispatch(
            slotsAction({ flag: "delete", value: { id: slotsInfo.id } })
        ).then(() => {
            dispatch(slotsAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "date") {
                        formattedItems["DateFrom"] = values[index][0];
                        formattedItems["DateTo"] = values[index][1];
                    } else if (key === "clubName") {
                        formattedItems["ClubId"] = values[index][0];
                    } else if (key === "time") {
                        formattedItems["TimeFrom"] = values[index][0];
                        formattedItems["TimeTo"] = values[index][1];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            slotsAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setSlotsInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            slotsAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            slotsAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        dispatch(slotsAction({ flag: "get" }));
    }, []);

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(slotsAction({ flag: "get", value: { isDeleted: value } }));
        setPage(1);
        setPageSize(20);
    };

    return (
        <>
            <AddEditSlotsModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                slotsInfo={slotsInfo}
                setPage={setPage}
                setPageSize={setPageSize}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={slotsListLoading}
                    onClickRowOne={(record) => {
                        setSlotsInfo(record);
                    }}
                    columns={slotsList}
                    rows={slotsList?.data?.value?.rows}
                    total={slotsList?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={slotsList}
                    elementsListLoading={slotsListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    items={items}
                    filterOptionsArr={filterOptionsArr}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    clickOnAction={clickOnAction}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Slots;
